import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const CookiePolicy = () => {
  const updated = "June 18, 2026";

  const openPrefs = () => {
    try {
      localStorage.removeItem("mystudio_cookie_consent");
    } catch {}
    window.dispatchEvent(new Event("mystudio:open-cookie-consent"));
  };

  return (
    <>
      <Helmet>
        <title>Cookie Policy | MyStudio Columbus GA</title>
        <meta name="description" content="Cookie Policy for MyStudio Columbus, GA — what cookies we use and how to manage your preferences." />
        <link rel="canonical" href="https://bookmystudiospace.com/cookie-policy" />
      </Helmet>
      <article className="container mx-auto px-4 lg:px-8 py-16 max-w-3xl">
        <h1 className="font-display text-3xl md:text-4xl tracking-wider mb-2">Cookie Policy</h1>
        <p className="text-xs text-muted-foreground font-body mb-10">Last updated: {updated}</p>

        <div className="prose prose-invert max-w-none font-body text-sm text-muted-foreground space-y-6 [&_h2]:text-foreground [&_h2]:font-display [&_h2]:tracking-wider [&_h2]:text-lg [&_h2]:mt-10 [&_h2]:mb-3 [&_a]:text-primary">
          <p>This Cookie Policy explains how MyStudio Columbus, GA uses cookies and similar technologies on <a href="https://bookmystudiospace.com">bookmystudiospace.com</a>.</p>

          <h2>What Are Cookies?</h2>
          <p>Cookies are small text files stored on your device by your browser. They help websites remember your preferences, keep you signed in, and understand how you use the site.</p>

          <h2>Types of Cookies We Use</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Strictly necessary</strong> — required for core functionality such as authentication, secure checkout, and form protection (e.g., session cookies, Google reCAPTCHA).</li>
            <li><strong>Analytics</strong> — help us understand how visitors use the site so we can improve it (Google Analytics).</li>
            <li><strong>Advertising</strong> — used to measure ad performance and show relevant ads on other sites (Meta/Facebook Pixel).</li>
          </ul>

          <h2>Third-Party Services</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Google Analytics — <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a></li>
            <li>Meta (Facebook) Pixel — <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer">facebook.com/privacy/policy</a></li>
            <li>Google reCAPTCHA — <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a></li>
            <li>Stripe (payment processing) — <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a></li>
          </ul>

          <h2>Managing Your Preferences</h2>
          <p>You can accept or decline non-essential cookies using our consent banner. To change your choice at any time, click the button below or clear your browser's site data.</p>
          <p>
            <button
              onClick={openPrefs}
              className="bg-primary text-primary-foreground px-6 py-2 font-display tracking-[0.15em] text-xs hover:bg-primary/90 transition-colors"
            >
              MANAGE COOKIE PREFERENCES
            </button>
          </p>
          <p>Most browsers also let you block or delete cookies directly. Note that disabling strictly necessary cookies may prevent parts of the site from working.</p>

          <h2>More Information</h2>
          <p>See our <Link to="/privacy-policy">Privacy Policy</Link> for how we handle personal information collected through these technologies.</p>

          <h2>Contact</h2>
          <p>Questions? Email <a href="mailto:services@bookmystudiospace.com">services@bookmystudiospace.com</a>.</p>
        </div>
      </article>
    </>
  );
};

export default CookiePolicy;